import { render, staticRenderFns } from "./CriteriaList.vue?vue&type=template&id=6543e62a&scoped=true&"
import script from "./CriteriaList.vue?vue&type=script&lang=js&"
export * from "./CriteriaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6543e62a",
  null
  
)

export default component.exports